import { render, staticRenderFns } from "./ServicesBusinessCrypto.vue?vue&type=template&id=9faa2aa4&scoped=true"
import script from "./ServicesBusinessCrypto.vue?vue&type=script&lang=js"
export * from "./ServicesBusinessCrypto.vue?vue&type=script&lang=js"
import style0 from "./ServicesBusinessCrypto.vue?vue&type=style&index=0&id=9faa2aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faa2aa4",
  null
  
)

export default component.exports